export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
          联系我们
        </h2>
        <p className="text-sm text-foreground-500 mb-10">
          欢迎漫画作者投稿合作，读者咨询与建议反馈
        </p>

        <div className="rounded-2xl bg-background-50 border border-background-200 p-8 md:p-10">
          <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-primary-100 flex items-center justify-center">
            <i className="ri-mail-send-line text-2xl text-primary-600"></i>
          </div>
          <h3 className="font-heading text-xl font-semibold text-foreground-900 mb-3">
            投稿与合作咨询
          </h3>
          <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-md mx-auto">
            无论您是独立漫画作者还是工作室团队，妖精漫画网欢迎优质原创漫画入驻。
            读者如有任何阅读体验问题或建议，也欢迎随时与我们取得联系。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <div className="flex items-center gap-2 px-5 py-3 rounded-full bg-secondary-100 text-secondary-800 text-sm">
              <i className="ri-mail-line"></i>
              <span>contact@yaojingcomic.com</span>
            </div>
            <div className="flex items-center gap-2 px-5 py-3 rounded-full bg-accent-100 text-accent-800 text-sm">
              <i className="ri-wechat-line"></i>
              <span>妖精漫画网官方</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}